import _regeneratorRuntime from "@babel/runtime/regenerator";

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import React, { useState } from "react";
import { reduxForm, change } from "redux-form";
import { Callout, Card, Intent } from "@blueprintjs/core";
import immer from "immer";
import "./UploadCsvWizard.css";
import { forEach } from "lodash";
import { flatMap } from "lodash";
import { compose } from "recompose";
import SimpleStepViz from "./SimpleStepViz";
import { nanoid } from "nanoid";
import tgFormValues, { tgFormValueSelector } from "./utils/tgFormValues";
import { some } from "lodash";
import { times } from "lodash";
import { ReactSelectField, SwitchField } from "./FormComponents";
import DialogFooter from "./DialogFooter";
import DataTable from "./DataTable";
import wrapDialog from "./wrapDialog";
import { omit } from "lodash";
import showConfirmationDialog from "./showConfirmationDialog";
import { connect } from "react-redux";
var UploadCsvWizardDialog = compose(reduxForm({
  form: "correctCSVHeadersForm"
}), connect(undefined, {
  changeForm: change
}), wrapDialog({
  canEscapeKeyClose: false,
  title: "Upload Helper",
  style: {
    width: "fit-content"
  }
}), tgFormValueSelector("editableCellTable", "reduxFormEntities", "reduxFormCellValidation"))(function UploadCsvWizardDialog(_ref) {
  var validateAgainstSchema = _ref.validateAgainstSchema,
      initialMatchedHeaders = _ref.initialMatchedHeaders,
      userSchema = _ref.userSchema,
      searchResults = _ref.searchResults,
      onUploadWizardFinish = _ref.onUploadWizardFinish,
      csvValidationIssue = _ref.csvValidationIssue,
      handleSubmit = _ref.handleSubmit,
      onlyShowRowsWErrors = _ref.onlyShowRowsWErrors,
      reduxFormEntities = _ref.reduxFormEntities,
      reduxFormCellValidation = _ref.reduxFormCellValidation,
      changeForm = _ref.changeForm;

  var _useState = useState(),
      hasSubmitted = _useState[0],
      setSubmitted = _useState[1];

  var _useState2 = useState([{
    text: "Set Headers",
    active: true
  }, {
    text: "Review Data",
    active: false
  }]),
      steps = _useState2[0],
      setSteps = _useState2[1];

  var flippedMatchedHeaders = {};

  var _React$useState = React.useState(initialMatchedHeaders),
      matchedHeaders = _React$useState[0],
      setMatchedHeaders = _React$useState[1];

  forEach(matchedHeaders, function (v, k) {
    if (v) flippedMatchedHeaders[v] = k;
  });
  var inner;

  if (hasSubmitted) {
    inner = /*#__PURE__*/React.createElement(PreviewCsvData, {
      initialEntities: reduxFormEntities,
      matchedHeaders: matchedHeaders,
      onlyShowRowsWErrors: onlyShowRowsWErrors,
      validateAgainstSchema: validateAgainstSchema,
      userSchema: userSchema
    });
  } else {
    inner = /*#__PURE__*/React.createElement("div", {
      style: {
        maxWidth: 500
      }
    }, /*#__PURE__*/React.createElement(Callout, {
      style: {
        width: "fit-content"
      },
      intent: "warning"
    }, csvValidationIssue), /*#__PURE__*/React.createElement("br", null), searchResults.map(function (_ref2, i) {
      var _ref6, _userSchema$userData;

      var path = _ref2.path,
          type = _ref2.type;
      var userMatchedHeader = matchedHeaders[i];
      return /*#__PURE__*/React.createElement(Card, {
        style: {
          padding: 2
        },
        key: i
      }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", {
        style: {
          display: "flex",
          minHeight: 50,
          alignItems: "center",
          justifyContent: "space-between"
        }
      }, /*#__PURE__*/React.createElement("td", {
        style: {
          width: 200,
          display: "flex"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          paddingTop: 2,
          marginLeft: 15,
          fontSize: 15
        }
      }, /*#__PURE__*/React.createElement("span", {
        "data-tip": "Column Type: " + (typeToCommonType[type || "string"] || type)
      }, path))), /*#__PURE__*/React.createElement("td", {
        style: {
          width: 200
        }
      }, /*#__PURE__*/React.createElement(ReactSelectField, {
        noMarginBottom: true,
        tooltipError: true,
        beforeOnChange: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var doAction;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(reduxFormEntities && reduxFormEntities.isDirty)) {
                    _context.next = 11;
                    break;
                  }

                  _context.next = 3;
                  return showConfirmationDialog({
                    text: "Are you sure you want to edit the columm mapping? This will clear any changes you've already made on the subsequent page.",
                    intent: Intent.DANGER,
                    //applied to the right most confirm button
                    confirmButtonText: "Yes",
                    cancelButtonText: "No" // canEscapeKeyCancel: true //this is false by default

                  });

                case 3:
                  doAction = _context.sent;

                  if (!doAction) {
                    _context.next = 8;
                    break;
                  }

                  changeForm("editableCellTable", "reduxFormEntities", null);
                  _context.next = 9;
                  break;

                case 8:
                  return _context.abrupt("return", {
                    stopEarly: true
                  });

                case 9:
                  _context.next = 12;
                  break;

                case 11:
                  if (reduxFormEntities) {
                    changeForm("editableCellTable", "reduxFormEntities", null);
                  }

                case 12:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        })),
        onChange: /*#__PURE__*/function () {
          var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(val) {
            var _extends2;

            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    //when the column mapping changes, update the column in reduxFormEntities (if reduxFormEntities exists)
                    setMatchedHeaders(_extends({}, matchedHeaders, (_extends2 = {}, _extends2[i] = val, _extends2)));

                  case 1:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          return function (_x) {
            return _ref4.apply(this, arguments);
          };
        }(),
        name: path // isRequired={!allowEmpty && defaultValue === undefined}
        ,
        defaultValue: matchedHeaders[i],
        options: flatMap(userSchema.fields, function (_ref5) {
          var path = _ref5.path;

          if (path !== matchedHeaders[i] && flippedMatchedHeaders[path]) {
            return [];
          }

          return {
            value: path,
            label: path
          };
        }).sort(function (a, b) {
          var ra = searchResults[i].matches.map(function (m) {
            return m.item.path;
          }).indexOf(a.value);
          var rb = searchResults[i].matches.map(function (m) {
            return m.item.path;
          }).indexOf(b.value);
          if (!ra) return -1;
          if (!rb) return 1;
          return rb - ra;
        })
      })), /*#__PURE__*/React.createElement("td", {
        style: {
          marginTop: 10,
          marginBottom: 10,
          marginLeft: 20,
          fontSize: 10
          /* color: Colors.RED1 */

        }
      }, userMatchedHeader && [(_ref6 = {}, _ref6[userMatchedHeader] = "Preview:", _ref6)].concat((_userSchema$userData = userSchema.userData) == null ? void 0 : _userSchema$userData.slice(0, 3)).map(function (row, i) {
        return /*#__PURE__*/React.createElement("div", {
          style: _extends({}, i === 0 && {
            fontWeight: "bold"
          }, {
            maxWidth: 70,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }),
          key: i
        }, row == null ? void 0 : row[userMatchedHeader]);
      }))))));
    }));
  }

  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: "fit-content"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement(SimpleStepViz, {
    style: {
      marginTop: 8
    },
    steps: steps
  })), /*#__PURE__*/React.createElement("div", {
    className: "bp3-dialog-body"
  }, inner), /*#__PURE__*/React.createElement(DialogFooter, _extends({
    text: !hasSubmitted ? "Review and Edit Data" : "Add File",
    disabled: hasSubmitted && (!(reduxFormEntities != null && reduxFormEntities.length) || some(reduxFormCellValidation, function (v) {
      return v;
    }))
  }, hasSubmitted && {
    onBackClick: function onBackClick() {
      setSteps(immer(steps, function (draft) {
        draft[0].active = true;
        draft[0].completed = false;
        draft[1].active = false;
      }));
      setSubmitted(false);
    }
  }, {
    onClick: handleSubmit( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!hasSubmitted) {
                //step 1 submit
                setSteps(immer(steps, function (draft) {
                  draft[0].active = false;
                  draft[0].completed = true;
                  draft[1].active = true;
                }));
                setSubmitted(true);
              } else {
                //step 2 submit
                onUploadWizardFinish({
                  newEntities: maybeStripIdFromEntities(reduxFormEntities, validateAgainstSchema)
                });
              }

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))),
    style: {
      alignSelf: "end"
    }
  })));
});
export default UploadCsvWizardDialog;
export var PreviewCsvData = tgFormValues("onlyShowRowsWErrors")(function (_ref8) {
  var formName = _ref8.formName,
      matchedHeaders = _ref8.matchedHeaders,
      headerMessage = _ref8.headerMessage,
      onlyShowRowsWErrors = _ref8.onlyShowRowsWErrors,
      validateAgainstSchema = _ref8.validateAgainstSchema,
      _ref8$userSchema = _ref8.userSchema,
      userSchema = _ref8$userSchema === void 0 ? {
    userData: times(5)
  } : _ref8$userSchema,
      initialEntities = _ref8.initialEntities;
  // const [loading, setLoading] = useState(true);
  // useEffect(() => {
  //   // simulate layout change outside of React lifecycle
  //   setTimeout(() => {
  //     setLoading(false);
  //   }, 400);
  // }, []);
  var data = userSchema.userData && userSchema.userData.length && userSchema.userData.map(function (row) {
    var toRet = {};
    validateAgainstSchema.fields.forEach(function (_ref9, i) {
      var path = _ref9.path,
          defaultValue = _ref9.defaultValue;
      var matchingKey = matchedHeaders == null ? void 0 : matchedHeaders[i];

      if (!matchingKey) {
        toRet[path] = defaultValue === undefined ? defaultValue : "";
      } else {
        toRet[path] = row[matchingKey];
      }

      if (toRet[path] === undefined || toRet[path] === "") {
        toRet[path] = defaultValue || "";
      }
    });

    if (row.id === undefined) {
      toRet.id = nanoid();
    } else {
      toRet.id = row.id;
    }

    return toRet;
  });
  return /*#__PURE__*/React.createElement("div", {
    style: {}
  }, /*#__PURE__*/React.createElement("h5", null, headerMessage || "Does this data look correct? Edit it as needed."), /*#__PURE__*/React.createElement(SwitchField, {
    name: "onlyShowRowsWErrors",
    inlineLabel: true,
    label: "Only Show Rows With Errors"
  }), /*#__PURE__*/React.createElement(DataTable, {
    maxWidth: 800,
    maxHeight: 500,
    initialEntities: initialEntities,
    destroyOnUnmount: false,
    formName: formName || "editableCellTable",
    isSimple: true,
    noAddMoreRowsButton: onlyShowRowsWErrors,
    onlyShowRowsWErrors: onlyShowRowsWErrors,
    isCellEditable: true,
    entities: data || [],
    schema: validateAgainstSchema
  }));
});
export var SimpleInsertDataDialog = compose(wrapDialog({
  canEscapeKeyClose: false,
  title: "Insert Data",
  style: {
    width: "fit-content"
  }
}), tgFormValueSelector("simpleInsertEditableTable", "reduxFormEntities", "reduxFormCellValidation"))(function SimpleInsertDataDialog(_ref10) {
  var onSimpleInsertDialogFinish = _ref10.onSimpleInsertDialogFinish,
      reduxFormEntities = _ref10.reduxFormEntities,
      reduxFormCellValidation = _ref10.reduxFormCellValidation,
      validateAgainstSchema = _ref10.validateAgainstSchema,
      r = _objectWithoutPropertiesLoose(_ref10, ["onSimpleInsertDialogFinish", "reduxFormEntities", "reduxFormCellValidation", "validateAgainstSchema"]);

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "bp3-dialog-body"
  }, /*#__PURE__*/React.createElement(PreviewCsvData, _extends({}, r, {
    validateAgainstSchema: validateAgainstSchema,
    formName: "simpleInsertEditableTable"
  }))), /*#__PURE__*/React.createElement(DialogFooter, {
    onClick: function onClick() {
      onSimpleInsertDialogFinish({
        newEntities: maybeStripIdFromEntities(reduxFormEntities, validateAgainstSchema)
      });
    },
    disabled: !(reduxFormEntities != null && reduxFormEntities.length) || some(reduxFormCellValidation, function (e) {
      return e;
    }),
    text: "Add File"
  }));
});
var typeToCommonType = {
  string: "Text",
  number: "Number",
  "boolean": "True/False",
  dropdown: "Select One"
};

function maybeStripIdFromEntities(ents, validateAgainstSchema) {
  var _validateAgainstSchem;

  if (validateAgainstSchema != null && (_validateAgainstSchem = validateAgainstSchema.fields) != null && _validateAgainstSchem.some(function (_ref11) {
    var path = _ref11.path;
    return path === "id";
  })) {
    return ents;
  } else {
    // if the schema we're validating against itself didn't have an id field,
    // we don't want to include it in the returned entities
    return ents == null ? void 0 : ents.map(function (e) {
      return omit(e, ["id"]);
    });
  }
}